import React from 'react';
import { User, Phone, Mail } from 'lucide-react';
import type { PendingFollowup } from './types';

interface Props {
  followup: PendingFollowup;
}

export function FollowupContactBlock({ followup }: Props) {
  const hasPerson =
    followup.contact_person_name ||
    followup.contact_person_phone ||
    followup.contact_person_email;

  if (
    !followup.pos_phone &&
    !followup.pos_email &&
    !hasPerson
  ) {
    return null;
  }

  return (
    <div className="p-3 bg-gray-50 rounded-xl mb-4 space-y-2">
      {followup.pos_phone && (
        <TelLink value={followup.pos_phone} />
      )}
      {followup.pos_email && (
        <MailLink value={followup.pos_email} />
      )}
      {hasPerson && (
        <PersonDetails followup={followup} />
      )}
    </div>
  );
}

function TelLink({ value }: { value: string }) {
  return (
    <a
      href={`tel:${value.replace(/\s+/g, '')}`}
      className={
        'flex items-center gap-2 text-xs md:text-sm text-green-700 ' +
        'font-bold active:scale-95 transition-all'
      }
    >
      <Phone size={15} className="text-green-500 flex-shrink-0" />
      <span>{value}</span>
    </a>
  );
}

function MailLink({ value }: { value: string }) {
  return (
    <a
      href={`mailto:${value}`}
      className={
        'flex items-center gap-2 text-xs md:text-sm text-blue-700 ' +
        'font-medium break-all active:scale-95 transition-all'
      }
    >
      <Mail size={15} className="text-blue-500 flex-shrink-0" />
      <span>{value}</span>
    </a>
  );
}

function PersonDetails({ followup }: Props) {
  return (
    <div className="space-y-2 pt-2 border-t border-gray-200">
      {followup.contact_person_name && (
        <div className="flex items-center gap-2 text-xs md:text-sm text-gray-700">
          <User size={15} className="text-gray-400 flex-shrink-0" />
          <span className="font-bold">{followup.contact_person_name}</span>
          {followup.contact_person_position && (
            <span className="text-gray-500">
              · {followup.contact_person_position}
            </span>
          )}
        </div>
      )}
      {followup.contact_person_phone && (
        <TelLink value={followup.contact_person_phone} />
      )}
      {followup.contact_person_email && (
        <MailLink value={followup.contact_person_email} />
      )}
    </div>
  );
}
